import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { GAME_CONFIG_PATH } from "utils/constants/paths";

const GameConfig = Loadable(React.lazy(() => import("./View")));

export const GameConfigRoute: IRouteItem = {
  path: GAME_CONFIG_PATH,
  element: React.createElement(GameConfig),
  accessKeys: ["Support", "ContentCreator", "Analyst", "SystemUserManager"],
  name: "Game Config",
  iconName: "Share",
};
